"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextMenuDisplayFormatter = exports.ActiveClass = exports.HighlightClass = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var TypeStyle = tslib_1.__importStar(require("typestyle"));
var Colors_1 = require("../../styles/Colors");
var PreventUserSelect_1 = require("../../styles/PreventUserSelect");
var TabStyles_1 = require("../../styles/TabStyles");
var TextEllipsis_1 = require("../../styles/TextEllipsis");
var Declarative_1 = require("../../utils/Declarative");
var DomUtil_1 = require("../../utils/DomUtil");
var DomWidgets_1 = require("../DomWidgets");
var Sizing = TabStyles_1.TabStyles.Sizing, Colors = TabStyles_1.TabStyles.Colors, Spacing = TabStyles_1.TabStyles.Spacing;
var GroupLabelClass = 'grouplabel';
exports.HighlightClass = 'highlight';
exports.ActiveClass = 'active';
var StyleName = TypeStyle.style(tslib_1.__assign(tslib_1.__assign({ display: 'flex', height: Sizing.ListRowHeight, lineHeight: Sizing.ListRowHeight + 'px', whiteSpace: 'nowrap' }, PreventUserSelect_1.PreventUserSelect), { $nest: (_a = {
            // item container
            '[role^="menuitem"] > &, [role="option"] > &': {
                paddingLeft: Spacing.DefaultSpace,
                paddingRight: Spacing.DefaultSpace,
            }
        },
        _a["&." + GroupLabelClass] = { fontWeight: 'bold' },
        _a["&." + exports.HighlightClass] = { backgroundColor: Colors.F2_5 },
        _a["&." + exports.ActiveClass] = { backgroundColor: Colors.F3 },
        _a['[aria-disabled="true"] > &'] = { color: Colors_1.TextColors.Disabled + " !important" },
        _a) }));
// item icon, text, and annotation
var GutterStyleName = TypeStyle.style({
    alignItems: 'center',
    display: 'inline-flex',
    flexShrink: 0,
    flexGrow: 0,
    marginLeft: -Spacing.DefaultSpace,
    justifyContent: 'center',
    width: 22,
});
var TextStyleName = TypeStyle.style(tslib_1.__assign(tslib_1.__assign({}, TextEllipsis_1.TextEllipsis), { flexGrow: 1 }));
var AnnotationStyleName = TypeStyle.style({
    color: Colors_1.TextColors.Neutral,
    flexShrink: 0,
    marginLeft: Spacing.DefaultSpace,
});
function isDataUri(s) {
    return (s === null || s === void 0 ? void 0 : s.indexOf('data:')) === 0;
}
/**
 * @param displayValue text value to display
 * @param tooltipOverride tooltip to display (overrides default overflow-tooltip behavior)
 */
exports.TextMenuDisplayFormatter = function (displayValue, tooltipOverride) {
    return /** @class */ (function (_super) {
        tslib_1.__extends(TextFormatterWidget, _super);
        function TextFormatterWidget() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.state = { title: tooltipOverride };
            _this.handleMouseOver = function (e) {
                if (tooltipOverride) {
                    // NOTE: The custom title will override the default title when the displayed value within the menu item is truncated.
                    return;
                }
                _this.setState({ title: (DomUtil_1.isElementOverflownX(e.currentTarget.querySelector("." + TextStyleName))) ? displayValue : undefined });
            };
            return _this;
        }
        TextFormatterWidget.prototype.render = function () {
            var _a;
            var annotation = this.props.annotation;
            var showGutter = this.props.showIconGutter && !this.props.isGroupLabel;
            return (React.createElement("div", { className: TypeStyle.classes(StyleName, this.props.isGroupLabel ? GroupLabelClass : (_a = {},
                    _a[exports.ActiveClass] = this.props.active,
                    _a[exports.HighlightClass] = this.props.isHighlighted,
                    _a)), "data-tb-test-id": Declarative_1.makeTestId(this.props.testId, 'TextMenuItem'), onMouseOver: this.handleMouseOver, title: this.state.title },
                showGutter && React.createElement("span", { key: 'gutter', className: GutterStyleName }, this.props.icon && React.createElement(DomWidgets_1.Img, { src: this.props.icon, "aria-hidden": true })),
                React.createElement("span", { key: 'text', className: TextStyleName }, displayValue /* this has to be in a span for text eliding to work in a flexbox */),
                annotation && React.createElement("span", { key: 'annotation', className: AnnotationStyleName }, isDataUri(annotation) ? React.createElement(DomWidgets_1.Img, { src: annotation, "aria-hidden": true }) : annotation)));
        };
        return TextFormatterWidget;
    }(React.PureComponent));
};
//# sourceMappingURL=TextMenuDisplayFormatter.js.map